import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'react-router-redux';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';

import './index.css';
import './inspectlet.js';
import history from './history';
import Router from './components/Router/Router';
import { rootEpic, rootReducer } from './ducks';
import registerServiceWorker from './registerServiceWorker';

const epicMiddleware = createEpicMiddleware();

const store = createStore(
  rootReducer,
  compose(applyMiddleware(epicMiddleware, routerMiddleware(history)))
);

epicMiddleware.run(rootEpic);
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00838F',
      light: '#4fb3bf',
      dark: '#005662',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#bdbdbd',
      light: '#efefef',
      dark: '#8d8d8d',
      contrastText: '#000000',
    },
  },
});

ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <Router />
      </Provider>
    </MuiThemeProvider>
  </MuiPickersUtilsProvider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();
